<template>
  <div class="main-sidebar">
    <a class="header" href="/">
      <img
        class="brand-logo"
        src="../assets/images/doc-flow-logo-alt.svg"
        alt="Gate Agent"
      />
      <span class="brand-text">Gate Agent</span>
    </a>
    <div class="body">
      <el-menu class="main-menu" router default-active="/devices">
        <el-menu-item index="/devices">Devices</el-menu-item>
        <el-menu-item index="/users">Users</el-menu-item>
        <el-menu-item index="/attendance">Attendance</el-menu-item>
        <el-menu-item index="/docs">Docs</el-menu-item>
      </el-menu>
    </div>
    <div class="footer"></div>
  </div>
</template>

<script>
export default {
  name: "MainSidebar",
};
</script>

<style lang="scss" scoped>
@import "../assets/styles/app-variables";
.main-sidebar {
  & > .header {
    text-decoration: none;
    padding: 0 20px;
    height: $--app-header-height;
    background-color: $--app-main-color;
    //box-shadow: 0 -6px 10px 6px $--app-main-color;
    display: flex;
    align-items: center;
    position: absolute;
    top: 0;
    width: 100%;
    left: 0;
    & > .brand {
      &-logo {
        height: 36px;
      }
      &-text {
        color: white;
        font-size: 28px;
        font-weight: 200;
        margin-left: 12px;
      }
    }
  }
  & > .body {
    position: absolute;
    top: $--app-header-height;
    bottom: $--app-header-height;
    width: 100%;
    left: 0;
    border-right: 1px solid $--app-sidebar-border-color;
    & > .main-menu {
      border-right: none;
      min-height: 100%;
      & .is-active {
        outline: none;
        background-color: #eaebeb;
      }
    }
  }
  & > .footer {
    position: absolute;
    border-right: 1px solid $--app-sidebar-border-color;
    bottom: 0;
    height: $--app-header-height;
    width: 100%;
    left: 0;
  }
}
</style>
